/**
 * Whether this browser can record at all. When it can't, the Voice and Video
 * tabs are hidden and the composer falls back to Text (GIFTWEB-21 AC 9).
 */
export const canRecordMedia = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.MediaRecorder !== 'undefined' &&
  typeof navigator !== 'undefined' &&
  typeof navigator.mediaDevices?.getUserMedia === 'function';

/** File types the photo picker offers, and the ones we accept on selection. */
export const PHOTO_ACCEPT = 'image/jpeg,image/png';

type PhotoRejection = 'type' | 'size';

/**
 * Validates a picked message photo (GIFTWEB-22 AC 4/5). Returns null when the
 * file is fine, otherwise which rule it broke — the caller owns the copy.
 */
export const validatePhotoFile = (
  file: File,
  { maxBytes, mimeTypes }: { maxBytes: number; mimeTypes: readonly string[] },
): PhotoRejection | null => {
  if (!mimeTypes.includes(file.type)) return 'type';
  if (file.size > maxBytes) return 'size';
  return null;
};
